<div class="login-container">
    @if (!isLoggedIn) {
        <div class="bg:grey-5 p-12 md:p-16 lg:p-24 border">
            <div class="grid-container">
                <div class="g-12 md:g-4">
                    <h4 class="p-12:b fw:bold c:blue-1">Hast du bereits eine Versicherung von uns?</h4>
                    <p>Melde dich bitte an und überspringe die Eingabe.</p>
                </div>
                <form
                    class="g-12 md:g-8"
                    [formGroup]="form"
                    (submit)="login()"
                >
                    <label
                        appReactiveLabel
                        formControlName="email"
                        for="email-input"
                        >E-Mail</label
                    >
                    <input
                        id="email-input"
                        type="email"
                        formControlName="email"
                        placeholder="E-Mail-Adresse"
                        [ctrlErrorMessage]="mailErrorMessages"
                        required
                    />
                    <label
                        appReactiveLabel
                        formControlName="password"
                        for="password-input"
                        >Passwort</label
                    >
                    <app-toggle-password>
                        <input
                            id="password-input"
                            type="password"
                            #passwordInput
                            formControlName="password"
                            placeholder="Passwort*"
                            [ctrlErrorMessage]="passwordErrorMessages"
                            required
                        />
                    </app-toggle-password>
                    <button
                        type="submit"
                        [disabled]="form.invalid"
                    >
                        Anmelden
                    </button>
                </form>
            </div>
        </div>
    } @else {
        <div class="bg:grey-5 p-12 md:p-16 lg:p-24 border">
            <div class="grid-container">
                <div class="g-12 fw:bold">
                    <h4 class="p-12:b fw:bold">Du bist nicht {{ customerName }}?</h4>
                </div>
                <div class="g-12 md:g-8">
                    <p>Melde dich bitte ab, um mit der Eingabe fortzufahren.</p>
                    <div class="p-24:t md:p-32:t lg:p-48:t md:hide"></div>
                </div>
                <div class="g-12 md:g-4">
                    <button
                        type="button"
                        class="button -dark"
                        (click)="logout()"
                    >
                        Abmelden
                    </button>
                </div>
            </div>
        </div>
    }
</div>
